import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/services/api';

export const dashboardActionsKey = ['dashboard-actions'] as const;

export function useDashboardActions() {
    return useQuery({
        queryKey: dashboardActionsKey,
        queryFn: async () => {
            const res = await dashboardApi.getActionItems();
            return res.data.data;
        },
        staleTime: 2 * 60 * 1000, // 2 minutes
    });
}
